module.exports = __webpack_public_path__ + "img/M007-17_jrb-04.ca44ee0d.jpg";